import { usePurchaseableProductsForTerm } from '../../../hooks/useBulkPurchaseOptions';
import { useCurrencyCodeUnitToDisplay, useDisplayedCurrencyCode } from '../../../hooks/useCurrencies';
import { useQueryParamTerm } from '../../../utils/urls/appQueryParamUtils';
import { default as SkeletonLoadWrapper } from '../../common/loading/SkeletonLoadWrapper';
import HighlightedFreePriceDisplay from '../price-display/HighlightedFreePriceDisplay';
import { PriceDisplayStyled } from '../price-display/PriceDisplayStyled';
import { jsx as _jsx } from "react/jsx-runtime";
export const ProductTilePrice = ({
  apiName,
  isHubspotFree
}) => {
  const currencyCode = useDisplayedCurrencyCode();
  const currencyCodeUnit = useCurrencyCodeUnitToDisplay();
  const {
    queryParamTerm
  } = useQueryParamTerm();
  const {
    purchaseOptionsForTerm,
    loading: isLoadingPurchaseOptions
  } = usePurchaseableProductsForTerm({
    queryParamTerm,
    apiName
  });
  if (isHubspotFree) {
    return /*#__PURE__*/_jsx(HighlightedFreePriceDisplay, {});
  }
  return /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
    isLoading: isLoadingPurchaseOptions,
    heights: [20],
    widths: ['100%'],
    children: purchaseOptionsForTerm && /*#__PURE__*/_jsx(PriceDisplayStyled, {
      pricingInfo: purchaseOptionsForTerm,
      seleniumId: apiName || 'loading',
      currencyCode: currencyCode,
      currencyCodeUnit: currencyCodeUnit
    })
  });
};
export default ProductTilePrice;